(function($) {
	$(document).ready(function(){
		let showBanner = getCookie('showpromobanner');

		if (showBanner !== "false") {
			$('header .top_pannel').slideDown(500);
		}
		$('header .top_pannel .close-icon').click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			$('header .top_pannel').slideUp(500);
			document.cookie = "showpromobanner=false; expires=" + now.toUTCString() + "; path=/";
		});

		// SET COOKIE CURRENCY =====================================================================================
		var currencyCookie = $.cookie('currency');
		if ( currencyCookie == undefined ) {
			Currency.cookie.write(theme.shopCurrency);
		}


		// CURRENCY SELECTOR ========================================================================================
		if ( typeof theme.shopCurrency != 'undefined' ) {

			var shopCurrency = theme.shopCurrency;

			// Sometimes merchants change their shop currency, let's tell our JavaScript file
			Currency.money_with_currency_format[shopCurrency] = theme.moneyFormatCurrency;
			Currency.money_format[shopCurrency] = theme.moneyFormat;

			// Cookie currency
			var cookieCurrency = Currency.cookie.read();

			// Saving the current price
			$('span.money').each(function() {
				$(this).attr( 'data-currency-' + theme.shopCurrency, $(this).html() );
			});

			// CHANGE CONTROLL ELEMENT DESKTOP/MOBILE
			var currencyActive = $('#currency_active');
			var currencySelector = $('#currency_selector');
			var currencySelectorItem = $('.currency_selector__item');

			currencySelectorItem.on('click', function(e) {
				var newCurrency = $(this).data('value');
				Currency.convertAll( Currency.currentCurrency, newCurrency, 'span.money', 'money_format' );
				$(this).addClass('current').siblings().removeClass('current');

				currencyActive.text(newCurrency);
				currencyActive.removeClass('opened');
				currencySelector.removeClass('opened');
			});

			currencySelectorItem.each(function() {
				var currencyValue = $(this).data('value');
				if ( currencyValue == cookieCurrency ) {
					currencyActive.text(currencyValue);
					$(this).addClass('current').siblings().removeClass('current');
				};
			});

			currencyActive.on('click', function() {
				if ( currencyActive.hasClass('opened') ) {
					currencyActive.removeClass('opened');
					currencySelector.removeClass('opened');
				}
				else {
					currencyActive.addClass('opened');
					currencySelector.addClass('opened');
				};
			});

			$(document).on('click', function(){
				if ( currencyActive.hasClass('opened') ) {
					currencyActive.removeClass('opened');
					currencySelector.removeClass('opened');
				};
			});

			currencyActive.on('click', function(e) {
				e.stopPropagation();
			});

			// If there's no cookie.
			if ( cookieCurrency == null ) {
				Currency.currentCurrency = shopCurrency;
			}
			// If the cookie value does not correspond to any value in the currency dropdown.
			else if ( $('#currency_selector li[data-value=' + cookieCurrency + ']').length === 0 ) {
				Currency.currentCurrency = shopCurrency;
				Currency.cookie.write(shopCurrency);
			}
			else if ( cookieCurrency === shopCurrency ) {
				Currency.currentCurrency = shopCurrency;
			}
			else {
				Currency.convertAll( shopCurrency, cookieCurrency, 'span.money', 'money_format' );
			};

		};

		// MEGAMENU =================================================================================================
		var mobFlag = 0;

		megamenuToggle = function() {
			if ( $(window).width() > 1199 ) {
				$('#megamenu, .menu-user').removeClass('megamenu_mobile').addClass('megamenu_desktop');

				$('#megamenu_level__1, #megamenu-links').superfish();

				// $('#megamenu .level_1, #megamenu .level_2, #megamenu .level_3, #megamenu .level_3_1').removeAttr('style');

				$('#megamenu_mobile_toggle, .megamenu_trigger').off('.mobileMenu').removeClass('off active');

				$('.menu-content, .megamenu_mobile_close,#megamenu_mobile_toggle, #megamenu-links').removeClass('on');

				$('html, body').css('overflow', 'auto');

				mobFlag = 0;
				
				turnMenuDropdownSide();
			}
			else {
				// $('.menu-content, .megamenu_mobile_close').hide();
				$('#megamenu, .menu-user').removeClass('megamenu_desktop').addClass('megamenu_mobile');

				$('#megamenu_level__1, #megamenu-links').superfish('destroy');

				if ( mobFlag == 0 ) {
					menuMobile();
					mobFlag = 1;
				};
			};
		};

		menuMobile = function() {
			$('#megamenu_mobile_toggle').on('click.mobileMenu', function(){
				$('#megamenu_mobile_toggle').addClass('on');
				$('.menu-content, .megamenu_mobile_close').show().addClass('on');

				$('html, body').css({'overflow': 'hidden', 'position':'fixed', 'top': '0', 'left': '0', 'right': '0'});

			});

			$('.megamenu_mobile_close').on('click', function() {
				$('.menu-content, .megamenu_mobile_close, #megamenu_mobile_toggle').removeClass('on');
				$('html, body').css({'overflow': 'auto', 'position':'static'});
			});

			$('.megamenu_trigger').on('click.mobileMenu', function() {
				var targetMenu = '#' + $(this).data('submenu');

				$(targetMenu).slideToggle(300);

				$(this).toggleClass('active');

				return false;
			});

		};

		// WATCH MENU DROP SIDE   ====================================================================================
		turnMenuDropdownSide = function() {
			$('#megamenu .is-simplemenu').each(function(i){
				if ( ($(this).offset().left + 470) > $(window).width() ){
					$(this).find('.droped_linklist').addClass('left_side');
				}
			});
		};

		// STICKY MENU  ==============================================================================================
		stickyHeader = function() {

			var target = $('.stickUpHeader');
			var pseudo = $('#pseudo_sticky_block');
			var stick_class = 'megamenu_stuck';

			$(window).on('load scroll resize', function() {

				if ( $(window).width() > 1199 ) {
					var scrolledValue = parseInt( $(window).scrollTop() );
					var offsetValue = parseInt( pseudo.offset().top );
					var headHeight = target.outerHeight();

					if ( scrolledValue > offsetValue ) {
						target.addClass( stick_class );
						pseudo.css({ 'height' : headHeight });
					}
					else {
						target.removeClass( stick_class );
						pseudo.css({ 'height' : 0 });
					};
				}
				else {
					target.removeClass( stick_class );
					pseudo.css({ 'height' : 0 });
				};

			});

			$(window).on('load', function() {
				setTimeout( 
					function(){ $(window).trigger('scroll') }
				, 180 );
			});
		};

		stickyHeader();
		megamenuToggle();

		// SEARCH TOGGLE  ===========================================================================================
		var headerSearchForm = $('header .search_form_wrap');

		$('.search_toggle').on('click', function(e){
			if ( headerSearchForm.hasClass('open') ){
				headerSearchForm.removeClass('open');
				$(this).removeClass('open');
			} else {
				headerSearchForm.addClass('open');
				$(this).addClass('open');
			}
		});

		$('header .search_form_wrap .search_form_cover').on('click',function (e) {
			if ( headerSearchForm.hasClass('open') ) {
				headerSearchForm.removeClass('open');
				$('.search_toggle').removeClass('open');
				$('#search_result_container').removeClass('active').html('');
			};
		});

		$('.search_form_close').on('click', function(e){
			headerSearchForm.removeClass('open');
			$('.search_toggle').removeClass('open');
			$('#search_result_container').removeClass('active').html('');
		});

		$('[data-target]').on('click', function(){
			const targetSelector = this.getAttribute('data-target');
			$(this).toggleClass('active');
			$(targetSelector).toggleClass('active');
		});
		

		// AJAX SEARCH  =============================================================================================
		if( theme.searchAjaxOn ){
			var container = $('#search_result_container');
			var url = '/search?q=';
			var search_form = $('.header_search .search_form_wrap');
			if (search_form.hasClass('.open')) {
			}
			$('.header_search input[type=search]').on('keyup', function(e){
				var inputVal = $(this).val(),
				_that = $(this);
				
				if(_that){
					setTimeout(function(){
						return false;
					}, 0);
				}
				
				
				
				if(e.key == "Backspace" || e.key == "Delete"){
					container.load(url + inputVal + ' #hidden_search_result> *');
				}

				if( inputVal.length > 2 ){
					container.addClass('active');
					container.load(url + inputVal + ' #hidden_search_result> *', function(){
						var list = container.find('ul');
						if ( parseInt( list.data('count_result') ) > 10 ){
							list.append('<li class="centred"><a class="btn btn-secondary mt-1" href="' + url + inputVal + '">' + list.data('caption') + ': ' + list.data('count_result') + '</a></li>');
						}
					});
				}
			});
		}

		// FOOTER NEWSLETTER FORM
		$('.footer_newsletter_form').each(function (){   
			$(this).on('submit', function(e){
				var formCookie = $(this).attr('class');
				$.cookie('footerformSended', formCookie);
			});
		});
		
		if( document.location.href.indexOf('?customer_posted=true') > 0 && $.cookie('footerformSended') == 'footer_newsletter_form') {
			$('.footer_newsletter_form .form_wrapper').hide();
			$('.footer_newsletter_form .alert-success').show();
		}
	});
})(jQuery);


// Megamenu
function setupVerticalNavigationMoreButton(){
	const showButton = $('.js-show-categories');
	const hideButton = $('.js-hide-categories');
	showButton.on('click', function () {
		$('.column-menu .megamenu-wrapper')[0].style.height = '';
		hideButton.removeClass('d-none');
		showButton.addClass('d-none');

		const items = $('.column-menu ul.megamenu > li.d-none');
		items.each((index, item) => {
			$(item).removeClass('d-none');
		})
	});

	hideButton.on('click', function () {
		$('.column-menu .megamenu-wrapper').outerHeight(getVerticalNavigationHeight());
		hideButton.addClass('d-none');
		showButton.removeClass('d-none');
		hideVeticalNavigationCollapsedItems();
	});
}

$(document).ready(function () {
	setupVerticalNavigationMoreButton();
});

function getVerticalNavigationHeight() {
	const prevElement = $('.index-section-slideshow').prev();
	const prevHeight = prevElement.hasClass('section_divider') ? prevElement.height() : 0;
	return $('.index-section-slideshow .slideshow_image').height() + prevHeight;
}

function hideVeticalNavigationCollapsedItems() {
	const visibleItemsCount = getVerticalNavigationVisibleItems();

	$('.column-menu ul.megamenu > li').each((index, item) => {
		if (index > visibleItemsCount - 1) {
			$(item).addClass('d-none');
		} else {
			$(item).removeClass('d-none');
		}
	})
}

function getVerticalNavigationVisibleItems() {
	const buttonHeight = 50;
	const itemMargin = 14;
	const nav = $('.column-menu');
	const items = nav.find('ul.megamenu > li');
	const navHeight = nav.find('ul.megamenu').innerHeight();

	let visibleItemsHeight = 0;
	let itemsCount = 0;

	items.each((index, item) => {
		let height = visibleItemsHeight += $(item).height();
		if (index !== 0) {
			height += itemMargin;
		}
		if (navHeight - buttonHeight - height >= 0) {
			visibleItemsHeight = height;
			itemsCount++;
		} else {
			return false;
		}
	});

	return itemsCount;
}

function processVerticalNavigation() {
	if (!document.body.classList.contains('template-index')) return;

	const showButton = $('.js-show-categories');
	const hideButton = $('.js-hide-categories');

	if ($(document).width() < 1200) {
		if (!$('.column-menu .megamenu-wrapper').length) return;
		$('.column-menu .megamenu-wrapper')[0].style.height = '';
		showButton.addClass('d-none');
		hideButton.addClass('d-none');
		return;
	}

	const topColumnHeight = getVerticalNavigationHeight();
	const nav = $('.column-menu');
	if (!nav || !topColumnHeight) return;

	nav.find('.megamenu-wrapper').outerHeight(topColumnHeight);
	const items = nav.find('ul.megamenu > li');
	const visibleItemsCount = getVerticalNavigationVisibleItems();
	const shouldShowButton = items.length - visibleItemsCount !== 0;
	if (!shouldShowButton) return;
	showButton.removeClass('d-none');
	hideVeticalNavigationCollapsedItems();
}

function processHorizontalNavigation(){
	const additionalMenuItem = $('.additional-menu-item');
	const additionalMenuList = additionalMenuItem.find('> ul');
	const nav = $('.default-menu.horizontal-menu');
	const navItems = nav.find('> ul > li');

	if ($(document).width() < 1200) {
		additionalMenuItem.addClass('d-none');
		const navList = nav.find('> ul');
		additionalMenuList.find('> li').each((index, item) => {
			$(item).insertBefore(additionalMenuItem);
		});
		return;
	}

	let firstItemTop = 0;
	let hasCollapsedItems = false;
	let lastVisibleItemIndex = 0;
	// Move items to additional-menu-list
	navItems.each((index, item) => {
		if (item.classList.contains('additional-menu-item')) return;
		const top = $(item).position().top;
		if (index === 0){
			firstItemTop = top;
		}else{
			if (top !== firstItemTop){
				hasCollapsedItems = true;
				additionalMenuList.append(item);
			}else{
				lastVisibleItemIndex = index;
			}
		}

	});

	if (!hasCollapsedItems) return;

	additionalMenuItem.removeClass('d-none');

	while (additionalMenuItem.position().top !== firstItemTop){
		additionalMenuList.prepend(navItems.get(lastVisibleItemIndex));
		lastVisibleItemIndex--;
	}
}

$(window).load(function () {
	prevDocumentWidth = $(document).width();
	processVerticalNavigation();
	processHorizontalNavigation();
});

$(window).resize(function () {
	const width = $(document).width();
	if ((prevDocumentWidth < 1200 && width >= 1200) || (prevDocumentWidth >= 1200 && width < 1200)) {
		setTimeout(processVerticalNavigation, 100);
		setTimeout(processHorizontalNavigation, 100);
	}
	prevDocumentWidth = $(document).width();
});

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1);
		if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	}
	return "";
}